import { createFileRoute } from "@tanstack/solid-router";
import { TireCurvesPage } from "~/components/tire-curves";
import { parseTireSearch } from "~/lib/tire-search";

// Public reference page: the slip curves behind every tire compound in the
// game. It needs no login, so it can be linked from community posts, and the
// view state travels in the URL so a link opens the same chart.
export const Route = createFileRoute("/tuning/tires")({
  validateSearch: parseTireSearch,
  component: TiresRoute,
});

// The page keeps its own state and mirrors it into the URL; the parsed search
// only seeds it.
function TiresRoute() {
  const search = Route.useSearch();
  return <TireCurvesPage initial={search()} />;
}
